/**
 * @description: 广告素材尺寸卡片组件
 */
import classNames from 'classnames';
import React, { CSSProperties } from 'react';

import './index.scss';

export interface IAdMaterialSizeCard {
  /**
   * 广告位类型
   */
  sizeName?: string
  /**
   * 类名
   */
  className?: string
  /**
   * 追加样式
   */
  style?: CSSProperties
  /**
   * 是否选中
   * @default false
   */
  isChecked?: boolean
  /**
   * 是否多选
   * @default false
   */
  isMultiple?: boolean
  /**
   * 点击事件
   */
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const AdMaterialSizeCard = (props: IAdMaterialSizeCard) => {
  const { sizeName, className, style, isChecked = false, isMultiple = false, onClick } = props;
  return (
    <div
      className={classNames('odc-ad-material-size-card', {
        'odc-ad-material-size-card-checked': isChecked,
        [className as string]: className,
      })}
      style={style}
      onClick={onClick}
    >
      <div className="odc-ad-material-size-card-text">
        {sizeName}
      </div>
      <div className="odc-ad-material-size-card-check">
        <div className={classNames({
          'check-checkbox': isMultiple,
          'check-radio': !isMultiple,
        })}
        ></div>
      </div>
    </div>
  );
};

export default AdMaterialSizeCard;